var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { class: _vm.slideInClass },
        [
          _c("header", [_c("div", { staticClass: "jon" }, [_c("Jon")], 1)]),
          _vm._v(" "),
          _c(
            "main",
            {
              ref: "main",
              staticClass: "scrollbar-check",
              attrs: { id: "job-questionnaire-main" }
            },
            [
              _vm.loading
                ? _c("Loading")
                : _c(
                    "div",
                    [
                      _vm.allDone
                        ? _c(
                            "div",
                            { staticClass: "all-done" },
                            [
                              _c("Avatar", {
                                attrs: { avatar: _vm.avatarRocket }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "all-done-text" }, [
                                _c("p", [
                                  _vm._v("Yeah, super, du hast alles erledigt!")
                                ]),
                                _vm._v(" "),
                                _vm.publishedJob
                                  ? _c("p", [
                                      _vm._v(
                                        "Dein anonymes Profil kann nun von Firmen gefunden werden."
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        : _vm.breakType
                        ? _c("BreakDisplay", { attrs: { type: _vm.breakType } })
                        : _vm._l(_vm.questionnaire.items, function(item, i) {
                            return _c(
                              "div",
                              {
                                key: item.id,
                                staticClass: "item-container",
                                class: { "d-none": i !== _vm.indexToEdit }
                              },
                              [
                                _vm.showMessages
                                  ? [
                                      _vm.forcedMessages
                                        ? _c(
                                            "div",
                                            { staticClass: "messages" },
                                            _vm._l(_vm.forcedMessages, function(
                                              message,
                                              j
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "forced-message--" + j,
                                                  staticClass: "message",
                                                  style: {
                                                    "animation-delay": j + "s"
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(message)
                                                    }
                                                  })
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "messages" },
                                            _vm._l(
                                              _vm.getMessages(item.id),
                                              function(message, j) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      "message--" +
                                                      item.id +
                                                      "--" +
                                                      j,
                                                    staticClass: "message",
                                                    style: {
                                                      "animation-delay": j + "s"
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          message
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "item-edit",
                                      item.id,
                                      i === _vm.indexToEdit
                                        ? "current"
                                        : undefined,
                                      _vm.skip ? "skip" : undefined
                                    ],
                                    style: {
                                      "animation-delay": _vm.showMessages
                                        ? _vm.getMessages(item.id).length + "s"
                                        : "0s"
                                    }
                                  },
                                  [
                                    _vm.isItemToEdit(
                                      "career-change-function",
                                      i
                                    )
                                      ? _c("CareerChangeFunction", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "career-change-function"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "career-change-function"
                                            ),
                                            "initial-functions":
                                              _vm.job.functions
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "career-change-function",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "career-change-industrial-sector",
                                      i
                                    )
                                      ? _c("CareerChangeIndustrialSector", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "career-change-industrial-sector"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "career-change-industrial-sector"
                                            ),
                                            "initial-industrial-sectors":
                                              _vm.job.industrialSectors
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "career-change-industrial-sector",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("working-hours", i)
                                      ? _c("WorkingHours", {
                                          class: {
                                            "d-none":
                                              item.id !== "working-hours"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "working-hours"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "working-hours",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("employment-duration", i)
                                      ? _c("EmploymentDuration", {
                                          class: {
                                            "d-none":
                                              item.id !== "employment-duration"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "employment-duration"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "employment-duration",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("start-date", i)
                                      ? _c("StartDate", {
                                          class: {
                                            "d-none": item.id !== "start-date"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("start-date")
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "start-date",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("function-assistance", i)
                                      ? _c("CharacteristicEdit", {
                                          class: {
                                            "d-none":
                                              item.id !== "function-assistance"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "function-assistance"
                                            ),
                                            title:
                                              "Assistenz-Tätigkeiten - Gib möglichst alles an, was dich grundlegend interessiert und auch Teil deiner Tätigkeit sein kann. Das erhöht deine Chancen!",
                                            "with-keyword": "",
                                            "characteristic-type":
                                              _vm.meta.functionAssistanceType,
                                            "characteristic-items":
                                              _vm.meta.functionAssistance,
                                            "nothing-allowed": {
                                              onlyOverall: true,
                                              overall: {
                                                text:
                                                  "Mir sind alle Tätigkeiten recht",
                                                inFan: true
                                              }
                                            },
                                            "open-fan-label":
                                              "Assistenz-Tätigkeiten auswählen",
                                            "open-fan-label-with-selection":
                                              "Assistenz-Tätigkeiten bearbeiten"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "function-assistance",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "function-marketing-role",
                                      i
                                    )
                                      ? _c("CharacteristicEdit", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "function-marketing-role"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "function-marketing-role"
                                            ),
                                            title:
                                              "Marketing-Tätigkeiten - Gib möglichst alles an, was dich grundlegend interessiert und auch Teil deiner Tätigkeit sein kann. Das erhöht deine Chancen!",
                                            "with-keyword": "",
                                            "characteristic-type":
                                              _vm.meta
                                                .functionMarketingRoleType,
                                            "characteristic-items":
                                              _vm.meta.functionMarketingRole,
                                            "nothing-allowed": {
                                              onlyOverall: true,
                                              overall: {
                                                text:
                                                  "Mir sind alle Tätigkeiten recht",
                                                inFan: true
                                              }
                                            },
                                            "open-fan-label":
                                              "Marketing-Tätigkeiten auswählen",
                                            "open-fan-label-with-selection":
                                              "Marketing-Tätigkeiten bearbeiten"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "function-marketing-role",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("function-legal-field", i)
                                      ? _c("CharacteristicEdit", {
                                          class: {
                                            "d-none":
                                              item.id !== "function-legal-field"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "function-legal-field"
                                            ),
                                            title:
                                              "Welche Rechtsgebiete möchtest du:",
                                            "with-keyword": "",
                                            "characteristic-type":
                                              _vm.meta.functionLegalFieldType,
                                            "characteristic-items":
                                              _vm.meta.functionLegalField,
                                            "nothing-allowed": {
                                              onlyOverall: true,
                                              overall: {
                                                text:
                                                  "Es sind alle Rechtsgebiete möglich",
                                                inFan: true
                                              }
                                            },
                                            "open-fan-label":
                                              "Rechtsgebiete auswählen",
                                            "open-fan-label-with-selection":
                                              "Rechtsgebiete bearbeiten"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "function-legal-field",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("function-legal-role", i)
                                      ? _c("CharacteristicEdit", {
                                          class: {
                                            "d-none":
                                              item.id !== "function-legal-role"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "function-legal-role"
                                            ),
                                            title:
                                              "Welche Rechtstätigkeiten möchtest du:",
                                            "with-keyword": "",
                                            "characteristic-type":
                                              _vm.meta.functionLegalRoleType,
                                            "characteristic-items":
                                              _vm.meta.functionLegalRole,
                                            "nothing-allowed": {
                                              onlyOverall: true,
                                              overall: {
                                                text:
                                                  "Es sind alle Rechtstätigkeiten möglich",
                                                inFan: true
                                              }
                                            },
                                            "open-fan-label":
                                              "Rechtstätigkeiten auswählen",
                                            "open-fan-label-with-selection":
                                              "Rechtstätigkeiten bearbeiten"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "function-legal-role",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("function-tax-field", i)
                                      ? _c("CharacteristicEdit", {
                                          class: {
                                            "d-none":
                                              item.id !== "function-tax-field"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "function-tax-field"
                                            ),
                                            title:
                                              "Welche Steuergebiete möchtest du:",
                                            "with-keyword": "",
                                            "characteristic-type":
                                              _vm.meta.functionTaxFieldType,
                                            "characteristic-items":
                                              _vm.meta.functionTaxField,
                                            "nothing-allowed": {
                                              onlyOverall: true,
                                              overall: {
                                                text:
                                                  "Es sind alle Steuergebiete möglich",
                                                inFan: true
                                              }
                                            },
                                            "open-fan-label":
                                              "Steuergebiete auswählen",
                                            "open-fan-label-with-selection":
                                              "Steuergebiete bearbeiten"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "function-tax-field",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("function-tax-role", i)
                                      ? _c("CharacteristicEdit", {
                                          class: {
                                            "d-none":
                                              item.id !== "function-tax-role"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "function-tax-role"
                                            ),
                                            title:
                                              "Welche Steuertätigkeiten möchtest du:",
                                            "with-keyword": "",
                                            "characteristic-type":
                                              _vm.meta.functionTaxRoleType,
                                            "characteristic-items":
                                              _vm.meta.functionTaxRole,
                                            "nothing-allowed": {
                                              onlyOverall: true,
                                              overall: {
                                                text:
                                                  "Es sind alle Steuertätigkeiten möglich",
                                                inFan: true
                                              }
                                            },
                                            "open-fan-label":
                                              "Steuertätigkeiten auswählen",
                                            "open-fan-label-with-selection":
                                              "Steuertätigkeiten bearbeiten"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "function-tax-role",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("experience-function", i)
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !== "experience-function"
                                          },
                                          attrs: {
                                            "sub-title":
                                              "Zu deinem Jobwunsch/Tätigkeitswunsch:",
                                            "characteristic-type":
                                              _vm.meta.functionType,
                                            "characteristic-items":
                                              _vm.meta.function,
                                            desire: _vm.job.functions,
                                            value: _vm.getItemData(
                                              "experience-function"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Tätigkeitserfahrung:",
                                              experience: {
                                                enabled: true,
                                                noneAllowed: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "supplements-config": {
                                              nothingAllowed: false,
                                              types: _vm.functionSupplementTypes
                                            },
                                            "further-messages": [
                                              "Hast du bisher weitere Tätigkeitserfahrungen gesammelt?<br/>Egal, ob privat oder beruflich! &#128512;",
                                              "Wichtig: Je mehr du angibst, desto höher deine Chancen.<br />Wieso? Arbeitgeber entscheiden zumeist danach, welche Erfahrungen insgesamt bisher gesammelt wurden und was man sonst noch kann. &#128076;"
                                            ],
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "experience-function"
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-function",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Tätigkeits-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "experience-function-legal-field",
                                      i
                                    )
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "experience-function-legal-field"
                                          },
                                          attrs: {
                                            "characteristic-type":
                                              _vm.meta.functionLegalFieldType,
                                            "characteristic-items":
                                              _vm.meta.functionLegalField,
                                            desire: [],
                                            value: _vm.getItemData(
                                              "experience-function-legal-field"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Rechtsgebiets-Erfahrung:",
                                              experience: {
                                                enabled: true,
                                                noneAllowed: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "experience-function-legal-field"
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-function-legal-field",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Rechtsgebiets-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "experience-function-legal-role",
                                      i
                                    )
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "experience-function-legal-role"
                                          },
                                          attrs: {
                                            "characteristic-type":
                                              _vm.meta.functionLegalRoleType,
                                            "characteristic-items":
                                              _vm.meta.functionLegalRole,
                                            desire: [],
                                            value: _vm.getItemData(
                                              "experience-function-legal-role"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Rechtstätigkeits-Erfahrung:",
                                              experience: {
                                                enabled: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "experience-function-legal-role"
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-function-legal-role",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Rechtstätigkeits-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "experience-function-marketing-role",
                                      i
                                    )
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "experience-function-marketing-role"
                                          },
                                          attrs: {
                                            "characteristic-type":
                                              _vm.meta
                                                .functionMarketingRoleType,
                                            "characteristic-items":
                                              _vm.meta.functionMarketingRole,
                                            desire: [],
                                            value: _vm.getItemData(
                                              "experience-function-marketing-role"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Marketingtätigkeits-Erfahrung:",
                                              experience: {
                                                enabled: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "experience-function-marketing-role"
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-function-marketing-role",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Marketingtätigkeits-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "experience-function-tax-field",
                                      i
                                    )
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "experience-function-tax-field"
                                          },
                                          attrs: {
                                            "characteristic-type":
                                              _vm.meta.functionTaxFieldType,
                                            "characteristic-items":
                                              _vm.meta.functionTaxField,
                                            desire: [],
                                            value: _vm.getItemData(
                                              "experience-function-tax-field"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Steuergebiet-Erfahrung:",
                                              experience: {
                                                enabled: true,
                                                noneAllowed: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "experience-function-tax-field"
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-function-tax-field",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Steuergebiet-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "experience-function-tax-role",
                                      i
                                    )
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "experience-function-tax-role"
                                          },
                                          attrs: {
                                            "characteristic-type":
                                              _vm.meta.functionTaxRoleType,
                                            "characteristic-items":
                                              _vm.meta.functionTaxRole,
                                            desire: [],
                                            value: _vm.getItemData(
                                              "experience-function-tax-role"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Steuertätigkeits-Erfahrung:",
                                              experience: {
                                                enabled: true,
                                                noneAllowed: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "experience-function-tax-role"
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-function-tax-role",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Steuerstätigkeits-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "experience-career-level",
                                      i
                                    )
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "experience-career-level"
                                          },
                                          attrs: {
                                            "sub-title":
                                              "Zu deinem Wunsch der Berufsebene:",
                                            "characteristic-type":
                                              _vm.meta.careerLevelType,
                                            "characteristic-items":
                                              _vm.meta.careerLevel,
                                            desire: _vm.job.careerLevels,
                                            value: _vm.getItemData(
                                              "experience-career-level"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Berufsebenen-Erfahrung:",
                                              experience: {
                                                enabled: true,
                                                noneAllowed: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "group-by-letter": {
                                              enabled: false
                                            },
                                            "button-text": "Erfahrung eingeben",
                                            "further-messages": [
                                              "Hast du bisher weitere Arbeitserfahrungen gesammelt?",
                                              "Wichtig: Je mehr du angibst, desto höher deine Chancen für den passenden Job. &#128077;"
                                            ],
                                            "further-messages-empty": [
                                              "Hast du bisher Arbeitserfahrungen gesammelt?",
                                              "Wichtig: Je mehr du angibst, desto höher deine Chancen für den passenden Job. &#128077;"
                                            ],
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.desireAdditionsFurtherAppeared(
                                                "experience-career-level",
                                                $event
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-career-level",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Berufsebenen-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("parking", i)
                                      ? _c("Parking", {
                                          class: {
                                            "d-none": item.id !== "parking"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("parking")
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "parking",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "experience-industrial-sector",
                                      i
                                    )
                                      ? _c("DesireAdditions", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "experience-industrial-sector"
                                          },
                                          attrs: {
                                            "sub-title":
                                              "Zu deinem Wunsch der Branche deines Arbeitgebers:",
                                            "characteristic-type":
                                              _vm.meta.industrialSectorType,
                                            "characteristic-items":
                                              _vm.meta.industrialSector,
                                            desire: _vm.job.industrialSectors,
                                            value: _vm.getItemData(
                                              "experience-industrial-sector"
                                            ),
                                            "addition-config": {
                                              inline: true,
                                              subTitle:
                                                "Zu deiner Branchen-Erfahrung:",
                                              experience: {
                                                enabled: true,
                                                noneAllowed: true
                                              },
                                              education: {
                                                enabled: false
                                              }
                                            },
                                            "further-messages": [
                                              "Hast du bisher weitere Branchen-Erfahrungen gesammelt?",
                                              "Wichtig: Je mehr du angibst, desto höher deine Chancen für den passenden Job. &#128077;"
                                            ],
                                            "label-type":
                                              _vm.labelTypeApplication
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "experience-industrial-sector"
                                              )
                                            },
                                            additionsEdit:
                                              _vm.onDesireAdditionsEdit,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "experience-industrial-sector",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "deleteConfirmText",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMöchtest du die Branchen-Erfahrung\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("Label", {
                                                      staticClass:
                                                        "font-weight-extra-bold",
                                                      attrs: {
                                                        characteristic:
                                                          data.item.item
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\twirklich entfernen?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("company-type", i)
                                      ? _c("SelectInline", {
                                          class: {
                                            "d-none": item.id !== "company-type"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "company-type"
                                            ),
                                            multiple: "",
                                            "initial-show-all": "",
                                            "characteristic-items":
                                              _vm.meta.companyType,
                                            "nothing-allowed": {
                                              text:
                                                "Ich bevorzuge keine bestimmte Art"
                                            },
                                            "show-multiple-hint": ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "company-type",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("company-size", i)
                                      ? _c("SelectInline", {
                                          class: {
                                            "d-none": item.id !== "company-size"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "company-size"
                                            ),
                                            multiple: "",
                                            "initial-show-all": "",
                                            "characteristic-items":
                                              _vm.meta.companySize,
                                            "nothing-allowed": {
                                              text:
                                                "Ich bevorzuge keine bestimmte Größe"
                                            },
                                            "show-multiple-hint": ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "company-size",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("management", i)
                                      ? _c("DesireExperience", {
                                          class: {
                                            "d-none": item.id !== "management"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "management"
                                            ),
                                            "characteristic-items":
                                              _vm.meta.managementKind
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "management",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "yes-text",
                                                fn: function() {
                                                  return [
                                                    _vm._v(
                                                      "Welche Führungsverantwortung möchtest du übernehmen?"
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("overtime", i)
                                      ? _c("Overtime", {
                                          class: {
                                            "d-none": item.id !== "overtime"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("overtime")
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "overtime",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("working-time", i)
                                      ? _c("WorkingTime", {
                                          class: {
                                            "d-none": item.id !== "working-time"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "working-time"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "working-time",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("languages", i)
                                      ? _c("Languages", {
                                          class: {
                                            "d-none": item.id !== "languages"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("languages"),
                                            meta: _vm.meta
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "languages",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("skills-software-main", i)
                                      ? _c("SelectInline", {
                                          class: {
                                            "d-none":
                                              item.id !== "skills-software-main"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "skills-software-main"
                                            ),
                                            "characteristic-items":
                                              _vm.meta.skillSoftwareMain,
                                            "nothing-allowed": {
                                              text:
                                                "Ich habe noch keine Erfahrung mit Büro-Software"
                                            },
                                            "with-self-assessment": ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "skills-software-main",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "skills-software-special",
                                      i
                                    )
                                      ? _c("SkillsSoftwareSpecial", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "skills-software-special"
                                          },
                                          attrs: {
                                            "with-info-text": "",
                                            value: _vm.getItemData(
                                              "skills-software-special"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "skills-software-special",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("customer-contact", i)
                                      ? _c("DesireExperience", {
                                          class: {
                                            "d-none":
                                              item.id !== "customer-contact"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "customer-contact"
                                            ),
                                            "characteristic-items":
                                              _vm.meta.businessModel
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "customer-contact",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "info-text",
                                                fn: function() {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tWähle aus, ob du Kundenkontakt möchtest.\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              },
                                              {
                                                key: "yes-text",
                                                fn: function() {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tMit welchen Kunden hättest du gerne Kontakt? Und hast du darin bereits Erfahrung\n\t\t\t\t\t\t\t\tgesammelt?\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              },
                                              {
                                                key: "irrelevant-text",
                                                fn: function() {
                                                  return [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tGib an, wenn du bereits Erfahrung gesammelt hast. Das erhöht deine Chancen!\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("public-transport", i)
                                      ? _c("PublicTransport", {
                                          class: {
                                            "d-none":
                                              item.id !== "public-transport"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "public-transport"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "public-transport",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("company-car", i)
                                      ? _c("CompanyCar", {
                                          class: {
                                            "d-none": item.id !== "company-car"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "company-car"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "company-car",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit(
                                      "private-vehicle-company-usage",
                                      i
                                    )
                                      ? _c("PrivateVehicleCompanyUsage", {
                                          class: {
                                            "d-none":
                                              item.id !==
                                              "private-vehicle-company-usage"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "private-vehicle-company-usage"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "private-vehicle-company-usage",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("driving-license", i)
                                      ? _c("SelectInline", {
                                          class: {
                                            "d-none":
                                              item.id !== "driving-license"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "driving-license"
                                            ),
                                            "characteristic-items":
                                              _vm.meta.drivingLicenseClass,
                                            "characteristic-type":
                                              _vm.meta.drivingLicenseClassType,
                                            "nothing-allowed": {
                                              text:
                                                "Ich habe keinen Führerschein"
                                            },
                                            "icon-path":
                                              "/img/characteristic/driving-license",
                                            "description-config": {
                                              inline: true
                                            },
                                            "initial-show-all": "",
                                            "show-multiple-hint": ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "driving-license",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("pilot-license", i)
                                      ? _c("SelectInline", {
                                          class: {
                                            "d-none":
                                              item.id !== "pilot-license"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "pilot-license"
                                            ),
                                            "characteristic-items":
                                              _vm.meta.pilotLicense,
                                            "nothing-allowed": {
                                              text:
                                                "Leider nicht ... Ich besitze keinen Flugschein"
                                            },
                                            "show-multiple-hint": "",
                                            "initial-show-all": ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "pilot-license",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("salary", i)
                                      ? _c("Salary", {
                                          class: {
                                            "d-none": item.id !== "salary"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("salary"),
                                            "employment-modes":
                                              _vm.employmentModes
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "salary",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("hourly-rate", i)
                                      ? _c("HourlyRate", {
                                          class: {
                                            "d-none": item.id !== "hourly-rate"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "hourly-rate"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "hourly-rate",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("skills", i)
                                      ? _c("Skills", {
                                          class: {
                                            "d-none": item.id !== "skills"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("skills")
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "skills",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("travel-willingness", i)
                                      ? _c("TravelWillingness", {
                                          class: {
                                            "d-none":
                                              item.id !== "travel-willingness"
                                          },
                                          attrs: {
                                            meta: _vm.meta,
                                            value: _vm.getItemData(
                                              "travel-willingness"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "travel-willingness",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("relocation", i)
                                      ? _c("Relocation", {
                                          class: {
                                            "d-none": item.id !== "relocation"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("relocation")
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "relocation",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("search-status", i)
                                      ? _c("SearchStatus", {
                                          class: {
                                            "d-none":
                                              item.id !== "search-status"
                                          },
                                          attrs: {
                                            value: _vm.getItemData(
                                              "search-status"
                                            ),
                                            questionnaire: ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "search-status",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isItemToEdit("education", i)
                                      ? _c("Education", {
                                          class: {
                                            "d-none": item.id !== "education"
                                          },
                                          attrs: {
                                            value: _vm.getItemData("education")
                                          },
                                          on: {
                                            furtherAppeared: function($event) {
                                              return _vm.addDisableSkip(
                                                "education"
                                              )
                                            },
                                            educationsChanged:
                                              _vm.onEducationsChanged,
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "education",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.id === "legitimation"
                                      ? _c("Legitimation", {
                                          attrs: {
                                            value: _vm.getItemData(
                                              "legitimation"
                                            ),
                                            meta: _vm.meta,
                                            job: _vm.job,
                                            item: item
                                          },
                                          on: {
                                            mustConfirmMobilePhone: function(
                                              $event
                                            ) {
                                              _vm.confirmMobilePhone = $event
                                            },
                                            revertMobilePhoneConfirmation: function(
                                              $event
                                            ) {
                                              _vm.confirmMobilePhone = undefined
                                            },
                                            input: function($event) {
                                              return _vm.setItemData(
                                                "legitimation",
                                                $event
                                              )
                                            },
                                            finish: _vm.onFinishLegitimation
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          })
                    ],
                    2
                  )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLegitimation
            ? _c("footer", { staticClass: "align-items-baseline" }, [
                _c("div", { staticClass: "footer--button-container" }, [
                  _c(
                    "div",
                    { staticClass: "flex-grow-1" },
                    [
                      _vm.indexToEdit > 0 &&
                      !_vm.loading &&
                      !_vm.allDone &&
                      !_vm.hideGoBack
                        ? _c("Button", {
                            attrs: {
                              text: "Zurück",
                              secondary: "",
                              disabled: !_vm.canGoBack || _vm.finishingItem
                            },
                            on: { click: _vm.goBack }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-md-right" },
                    [
                      _vm.allDone && _vm.publishedJob
                        ? _c("Button", {
                            attrs: {
                              text: "Zu den Matches",
                              icon: "checkmark",
                              href:
                                "/kandidat/profil/jobs?trackPageVisitEvent=1"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allDone && !_vm.publishedJob
                        ? _c("Button", {
                            attrs: { text: "Schließen", icon: "checkmark" },
                            on: { click: _vm.close }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.loading && !_vm.allDone
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-end flex-column-reverse flex-md-row"
                            },
                            [
                              !_vm.loading && _vm.canSkip
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass:
                                        "d-none d-md-block mr-2 mt-2 mt-md-0",
                                      attrs: { value: true },
                                      model: {
                                        value: _vm.skip,
                                        callback: function($$v) {
                                          _vm.skip = $$v
                                        },
                                        expression: "skip"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\tIch möchte diese Frage später beantworten.\n\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("Button", {
                                attrs: {
                                  text: "Weiter",
                                  icon: "checkmark",
                                  disabled:
                                    !_vm.canContinue || _vm.finishingItem,
                                  loading: _vm.finishingItem
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.finishItem(true)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-md-block font-size-smaller mt-3"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\tAlle deine Angaben können nachträglich noch geändert werden.\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-md-none mt-2" },
                  [
                    !_vm.loading && _vm.canSkip
                      ? _c(
                          "b-form-checkbox",
                          {
                            attrs: { value: true },
                            model: {
                              value: _vm.skip,
                              callback: function($$v) {
                                _vm.skip = $$v
                              },
                              expression: "skip"
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\tIch möchte diese Frage später beantworten.\n\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "font-size-smaller mt-3" }, [
                      _vm._v(
                        "\n\t\t\t\tAlle deine Angaben können nachträglich noch geändert werden.\n\t\t\t"
                      )
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showSkipWarningPopUp
            ? _c(
                "PopUp",
                {
                  attrs: {
                    title: "Hinweis",
                    "hide-close": "",
                    "cancel-text": "Trotzdem überspringen",
                    "ok-text": "Jetzt vervollständigen"
                  },
                  on: {
                    ok: _vm.onAcceptSkipWarning,
                    hidden: _vm.onCancelSkipWarning
                  }
                },
                [
                  _c("JonInfo", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "message",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n\t\t\t\tWenn Du deine Erfahrungen nicht vollständig eingibst, wirst du kaum Matches erhalten.\n\t\t\t"
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3932554894
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }